import React, { Dispatch, SetStateAction } from "react";
import styles from "./mobile-nav.module.scss";
import classNames from "classnames";
import Link from "next/link";
import { footerLinks } from "@components/layout/footer";

type Props = {
  isOpen: boolean;
};

const MobileNav = ({ isOpen }: Props) => {
  return (
    <div className={classNames(styles.container, isOpen && styles.open)}>
      <div className={styles.menu}>
        {footerLinks.map((linkGroup) => (
          <div key={linkGroup.columnName}>
            <div className={styles.linkGroupHeader}>{linkGroup.columnName}</div>
            <ul className={styles.links}>
              {linkGroup.links.map((subLink, index) => (
                <li key={subLink.name + index}>
                  <Link href={subLink.url}>{subLink.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileNav;
